import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PaginationResponse } from '@ml/shared/types/pagination-response';
import { Observable } from 'rxjs';
import { Notification } from '@ml/notifications/types/interfaces';
import { QueryParams } from '@ml/shared/types/query-params';
import { Params } from '@angular/router';

@Injectable()
export class NotificationsService {
  private readonly url = 'notifications';

  constructor(private http: HttpClient) {}

  list(
    queryParams?: QueryParams
  ): Observable<PaginationResponse<Notification>> {
    return this.http.get<PaginationResponse<Notification>>(this.url, {
      params: queryParams as Params
    });
  }

  unreadNotifications(): Observable<number> {
    return this.http.get<number>(`${this.url}/unread`);
  }

  delete(notificationId: number) {
    return this.http.delete(`${this.url}/${notificationId}`);
  }

  read(notificationId: number) {
    return this.http.post<void>(`${this.url}/${notificationId}/read`, {});
  }

  readAll() {
    return this.http.post<void>(`${this.url}/read-all`, {});
  }

  clearAll() {
    return this.http.post<void>(`${this.url}/clear-all`, {});
  }
}
